// extracted by mini-css-extract-plugin
export default {"text":"duplicate-file-detected_text__QpqLm","bold":"duplicate-file-detected_bold__xOK1n","button-row":"duplicate-file-detected_button-row__0d2iU"};